import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import isItemOfMessageType from 'mini-mail-triage-actions/lib/utils/isItemOfMessageType';
import Message from 'owa-service/lib/contract/Message';
import { getIsPinnedTimestamp } from '../utils/pinningUtils';
import { getOwaMiniStrings } from 'owa-strings/owa-mini-strings';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { MailListDataPropertyEnum } from './MailListDataPropertyEnum';

export default function getItemProperty(itemId: string, propertyType: MailListDataPropertyEnum) {
    const item = getMailStore().items.get(itemId);
    if (!item) {
        return null;
    }

    const message = isItemOfMessageType(item) ? (item as Message) : null;

    switch (propertyType) {
        case MailListDataPropertyEnum.LastDeliveryTimeStamp:
            return item.DateTimeReceived;

        case MailListDataPropertyEnum.LastDeliveryOrRenewTimeStamp:
            return item.ReceivedOrRenewTime;

        case MailListDataPropertyEnum.LastModifiedTime:
            return item.LastModifiedTime;

        case MailListDataPropertyEnum.Subject:
            return item.Subject || getOwaMiniStrings().noSubject;

        case MailListDataPropertyEnum.ParentFolderId:
            return item.ParentFolderId?.Id;

        case MailListDataPropertyEnum.UniqueRecipients:
            return item.DisplayTo ? [item.DisplayTo] : undefined;

        case MailListDataPropertyEnum.UniqueSenders:
            return message?.From?.Mailbox?.Name ? [message.From.Mailbox.Name] : undefined;

        case MailListDataPropertyEnum.LastSender:
            return message?.From;

        case MailListDataPropertyEnum.UnreadCount:
            // returns 1 if message exists and it's unread
            // returns 0 if message is read, or item is not Message type
            return message && !message.IsRead ? 1 : 0;

        case MailListDataPropertyEnum.PreviewText:
            return item.Preview;

        case MailListDataPropertyEnum.IsPinned:
            return getIsPinnedTimestamp(item.ReceivedOrRenewTime);

        case MailListDataPropertyEnum.FlagStatus:
            // item.Flag could be undefined in search results
            return item.Flag?.FlagStatus;

        case MailListDataPropertyEnum.ShouldShowRSVP:
            return (item as ClientItem).shouldShowRSVP;

        case MailListDataPropertyEnum.RsvpUnitAriaDetails:
            return (item as ClientItem).rsvpUnitAriaDetails;

        default:
            return null;
    }
}
